import React, { useState, useEffect } from "react";

import Footer from "../../components/shared/Footer";
import { OrganizationService } from "../../services/ClientService";
import { Globals } from "../../helpers/globals";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import CaseSearch from "./components/CaseSearch";
import CaseDisplay from "./components/CaseDisplay";

const steps = [
    {
        label: "Find Case",
        description: `Enter the sequence number for a case previously filed with us.`,
        component: <CaseSearch />,
        collaspedComponent: <CaseDisplay />,
    },
    {
        label: "Summons",
        description: "Drop your summons to be served",
    },
    {
        label: "Additional Documents",
        description: `Drop additional documents for each service job.`,
    },
];

export default function AddJobs() {
    const currentUser = Globals.currentUserValue;
    const [activeStep, setActiveStep] = React.useState(0);
    const [isDrop, setIsDrop] = useState(false);
    const [caseNumber, setCaseNumber] = useState("");
    const [jobs, setJobs] = useState([] as string[]);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    useEffect(() => {
        OrganizationService.isFileDrop({
            id: currentUser.organizationID!,
        }).then((res) => {
            if (res.successful!) {
                setIsDrop(res.data!);
            }
        });
    }, []);

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Service of Process</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            Service
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Create Job
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <Box>
                        <Stepper activeStep={activeStep} orientation="vertical">
                            {steps.map((step, index) => (
                                <Step key={step.label}>
                                    <StepLabel
                                        optional={
                                            index === 2 ? (
                                                <Typography variant="caption">
                                                    Last step
                                                </Typography>
                                            ) : null
                                        }
                                    >
                                        {step.label}
                                        {(activeStep != index &&
                                            step.collaspedComponent) ?? <></>}
                                    </StepLabel>
                                    <StepContent>
                                        <Typography>
                                            {step.description}
                                        </Typography>
                                        {step.component ?? <></>}
                                        <Box sx={{ mb: 2 }}>
                                            <div>
                                                <Button
                                                    variant="contained"
                                                    onClick={handleNext}
                                                    sx={{ mt: 1, mr: 1 }}
                                                >
                                                    {index === steps.length - 1
                                                        ? "Finish"
                                                        : "Continue"}
                                                </Button>
                                                <Button
                                                    disabled={index === 0}
                                                    onClick={handleBack}
                                                    sx={{ mt: 1, mr: 1 }}
                                                >
                                                    Back
                                                </Button>
                                            </div>
                                        </Box>
                                    </StepContent>
                                </Step>
                            ))}
                        </Stepper>
                        {activeStep === steps.length && (
                            <Paper square elevation={0} sx={{ p: 3 }}>
                                <Typography>
                                    All steps completed - you&apos;re finished
                                </Typography>
                                <Button
                                    onClick={handleReset}
                                    sx={{ mt: 1, mr: 1 }}
                                >
                                    Reset
                                </Button>
                            </Paper>
                        )}
                    </Box>
                </div>
            </div>
            <Footer />
        </div>
    );
}
